import { render, staticRenderFns } from "./AddLightCourseMaterialModal.vue?vue&type=template&id=334e97c3&"
import script from "./AddLightCourseMaterialModal.vue?vue&type=script&lang=js&"
export * from "./AddLightCourseMaterialModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports